import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CrownIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 15, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 13) / 15}
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.42967 0.569362C7.93343 -0.189784 6.80711 -0.189791 6.31087 0.569362L3.80539 4.40203L1.89031 3.31702C0.93088 2.77343 -0.222693 3.62531 0.0371979 4.68548L1.33826 9.99281C1.39684 10.2318 1.61382 10.4002 1.86326 10.4002H12.8773C13.1267 10.4002 13.3437 10.2318 13.4023 9.99281L14.7033 4.68548C14.9633 3.6253 13.8097 2.77343 12.8502 3.31702L10.9351 4.40203L8.42967 0.569362ZM7.52158 1.14594C7.45075 1.03749 7.28979 1.03749 7.21896 1.14593L4.43538 5.40398C4.27958 5.64233 3.96156 5.71846 3.71215 5.57717L1.35194 4.23997C1.21488 4.16232 1.05008 4.28402 1.08721 4.43547L2.28842 9.33553H12.4521L13.6534 4.43547C13.6904 4.28402 13.5257 4.16232 13.3886 4.23997L11.0284 5.57717C10.7789 5.71846 10.461 5.64233 10.3052 5.40398L7.52158 1.14594Z"
        fill="currentColor"
      />
      <path
        d="M2.33113 11.4648C2.03283 11.4648 1.79102 11.7032 1.79102 11.9972C1.79102 12.2911 2.03283 12.5295 2.33113 12.5295H12.4132C12.7115 12.5295 12.9533 12.2911 12.9533 11.9972C12.9533 11.7032 12.7115 11.4648 12.4132 11.4648H2.33113Z"
        fill="currentColor"
      />
    </svg>
  )
})
CrownIcon.displayName = 'CrownIcon'
